jQuery( $ => {
	const ctaGlobalSession = window.sessionStorage.getItem( 'cta_global_popup' );
	const ctaSpecificSession = window.sessionStorage.getItem( 'cta_specific_popup' );

	$( 'body' ).on( 'click', '.cta-popup-close-button', function() {
		$( '.cta-popup' ).css( 'display', 'none' );
		window.sessionStorage.setItem( 'cta_global_popup', 'true' );
	} );

	$( '.cta-popup-close-button-specific' ).click( function() {
		$( '.cta-popup-specific' ).css( 'display', 'none' );
		window.sessionStorage.setItem( 'cta_specific_popup', 'true' );
	} );

	if ( 'true' !== ctaGlobalSession ) {
		$( '.cta-popup' ).css( 'display', 'block' );
	}

	if ( 'true' !== ctaSpecificSession ) {
		$( '.cta-popup-specific' ).css( 'display', 'block' );
	}

	/* Rollupfunction for cta-popups. */
	if ( $( '.cta-popup.cta-hidden' ).length && ! $( '.mobile-open' ).length ) {
		if ( 'true' !== ctaGlobalSession ) {
			$( '.cta-popup' ).css( 'display', 'block' );
			$( '.cta-popup' ).removeClass( 'cta-hidden' );
		} else {
			$( '.cta-popup' ).css( 'display', 'none' );
		}
	}

	if ( $( '.cta-popup-specific.cta-hidden' ).length ) {
		if ( 'true' !== ctaSpecificSession ) {
			$( '.cta-popup-specific' ).css( 'display', 'block' );
			$( '.cta-popup-specific' ).removeClass( 'cta-hidden' );
		} else {
			$( '.cta-popup-specific' ).css( 'display', 'none' );
		}
	}
} );
